import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import 'bootstrap/dist/css/bootstrap.css'

const rootHandle = document.getElementById('root')

ReactDOM.render(<App />, rootHandle)